const {h, render, Component} = require('preact');
const OrderStatusContainer = require('../../containers/status/order_status')
const SSAButtons = require('../../containers/self_service_actions/ssa_buttons')

class OrderView extends Component {
  constructor(props) {
    super(props);
    this.configFromDom = Groupon.Utils.getConfigFromDom();
  };

  render() {
    let order = this.props.order;
    let landingView = this.configFromDom.showSSAOnLandingPage
    if(order){
      return (
        <td className="order-data-cell ch-bdr-prim ca-bdr-prim" width="50%" key={order.id} dealId={order.deal.id} onClick={this.props.orderDetails} data-bhw="web2018_order_summary">
          <table className="cell-table">
            <tr className="cell-row">
              <td className="image cell-column">
                <img src={order.deal.largeImageUrl} alt={"Deal Image" + order.merchant.name} />
              </td>
              <td className="order-info cell-column">
                <p className="b title"> {order.merchant.name}</p>
                <p className="description">{order.deal.title}</p>
                <OrderStatusContainer landingView={landingView} order={order} />
                {landingView ? <SSAButtons landingView={landingView} orderDetails = {order}/> : null}
              </td>
            </tr>
          </table>
        </td>
    )
  }
  return(<td></td>)
  }
}
module.exports = OrderView
